import type { WebPageSection } from "@/lib/api"
import { parseHtmlString } from '@/utils/helpers/html'

const FunctionsResponsibilities = ({data}:{data: {
  [key: string]: WebPageSection
}}) => {
  const functions = [
    {
      number: 1,
      title: `${data?.LEADERSHIP_STRATEGIC_AND_POLITICAL_OVERSIGHT?.title ?? 'Strategic and Political Oversight'}`,
      description: `${data?.LEADERSHIP_STRATEGIC_AND_POLITICAL_OVERSIGHT?.description ?? ""}`
    },
    {
      number: 2,
      title: `${data?.LEADERSHIP_GOVERNANCE_AND_LEADERSHIP_OF_AFSA?.title ?? 'Governance and Leadership of AfSA'}`,
      description: `${data?.LEADERSHIP_GOVERNANCE_AND_LEADERSHIP_OF_AFSA?.description ?? ""}`
    },
    {
      number: 3,
      title: `${data?.LEADERSHIP_ADVOCACY_AND_REPRESENTATION?.title ?? 'Advocacy and Representation'}`,
      description: `${data?.LEADERSHIP_ADVOCACY_AND_REPRESENTATION?.description ?? ""}`
    },
    {
      number: 4,
      title: `${data?.LEADERSHIP_COORDINATION_AND_LIAISON?.title ?? 'Coordination and Liaison'}`,
      description: `${data?.LEADERSHIP_COORDINATION_AND_LIAISON?.description ?? ""}`
    },
    {
      number: 5,
      title: `${data?.LEADERSHIP_ADVISORY_STRUCTURE_AND_COMMITTEE_MANAGEMENT?.title ?? 'Advisory Structure and Committee Management'}`,
      description: `${data?.LEADERSHIP_ADVISORY_STRUCTURE_AND_COMMITTEE_MANAGEMENT?.description ?? ""}`
    },
    {
      number: 6,
      title: `${data?.LEADERSHIP_PRIVATE_SECTOR_AND_STAKEHOLDER_ENGAGEMENT?.title ?? 'Private Sector and Stakeholder Engagement'}`,
      description: `${data?.LEADERSHIP_PRIVATE_SECTOR_AND_STAKEHOLDER_ENGAGEMENT?.description ?? ""}`
    }
  ]

  const FunctionCard = ({ func }: { func: typeof functions[0] }) => (
    <div className="min-h-[420px] md:min-h-[478px] px-6 md:px-8 py-6 bg-duskySky-100 flex justify-start items-start gap-2 overflow-hidden">
      <div className="w-full max-w-sm flex flex-col justify-start items-start gap-8">
        <div className="w-12 h-12 bg-wine-200 rounded flex items-center justify-center">
          <span className="text-white text-2xl md:text-3xl font-normal font-pt-serif">
            {func.number}
          </span>
        </div>
        
        <div className="flex flex-col gap-4">
          <h3 className="text-gray-100 text-lg md:text-2xl font-normal font-pt-serif leading-7">
            {func.title}
          </h3>
          
          <div className="flex flex-col gap-4">
              <p  className="text-gray-100 text-base md:text-lg font-normal font-satoshi leading-relaxed">
                <span dangerouslySetInnerHTML={parseHtmlString(func.description)} />
              </p>
           
          </div>
        </div>
      </div>
    </div>
  )

  return (
    <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="flex flex-col gap-12">
        <h2 className="text-2xl md:text-4xl font-normal font-pt-serif text-gray-100 leading-tight md:leading-[48px]">
          {data?.LEADERSHIP_FUNCTIONS_AND_RESPONSIBILITIES?.title ?? "Functions & Responsibilities"}
        </h2>
        
        {/* Grid Layout for Functions */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {functions.map((func) => (
            <FunctionCard key={func.number} func={func} />
          ))}
        </div>
      </div>
    </div>
  )
}

export default FunctionsResponsibilities